import { Anchor, Group, Stack, Text } from '@mantine/core';
import React from 'react';
import DocumentsDropzoneShell, {
  DropStateLabel,
  DropzoneIcon,
  SupportedFormatsHint,
} from './DocumentsDropzoneShell';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type DocumentsDropZoneProps = {
  onFilesSelected: (files: File[]) => void;
  onSharePointClick: (e: React.MouseEvent<HTMLElement>) => void;
};

export default function DocumentsDropZone({
  onFilesSelected,
  onSharePointClick,
}: DocumentsDropZoneProps) {
  return (
    <DocumentsDropzoneShell onFilesSelected={onFilesSelected} testId="documents-drop-zone">
      <Group gap="sm" wrap="nowrap" align="center">
        <DropzoneIcon />
        <Stack gap="xxxs" align="flex-start">
          <Text size="md" fw={FONT_WEIGHTS.medium} c="gray.10" lh="24px" maw={486}>
            <DropStateLabel idle="Drag and drop files here" />
          </Text>
          <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.8" lh="20px" maw={486}>
            Add from{' '}
            <Anchor
              component="button"
              size="sm"
              fw={FONT_WEIGHTS.medium}
              c="brand.7"
              underline="always"
              onClick={onSharePointClick}
              data-testid="drop-zone-share-point"
            >
              SharePoint/OneDrive
            </Anchor>{' '}
            or from your{' '}
            <Anchor
              component="button"
              size="sm"
              fw={FONT_WEIGHTS.medium}
              c="brand.7"
              underline="always"
              data-testid="drop-zone-computer"
            >
              computer
            </Anchor>
          </Text>
          <SupportedFormatsHint />
        </Stack>
      </Group>
    </DocumentsDropzoneShell>
  );
}
